import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgItalic01 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 4h-9m4 16H5M15 4 9 20"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgItalic01)
export default ForwardRef
